var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 10,
  fill: "none",
  viewBox: "0 0 9 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F1F1F",
  fillRule: "evenodd",
  d: "m4.5 8-.338-.327-.338-.326L.338 3.98 0 3.653.676 3l.338.326L4.5 6.695l3.486-3.367L8.324 3 9 3.653l-.338.327-3.486 3.367-.338.326z",
  clipRule: "evenodd",
  opacity: 0.7
})));
export default SvgArrowDown;